import React from "react";

export default function FlowChoice({ label, compact = false, children }) {
  return <label className={`choice${compact ? " compact" : ""}`}><span className="choice-name">{label}</span>{React.isValidElement(children) && children.type === "select" ? React.cloneElement(children, { className: `ib-select ${children.props.className || ""}` }) : children}</label>;
}
